// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2mJwR","signatureButtonsRight":"ModalSign_signatureButtonsRight__3v1hJ"};